import { Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Loader from "./../../component/Loader";
import {
  getContactInfo,
  formContact,
  getSocialMedia,
} from "../../store/contact/contactAction";
import { sucess, failed } from "../../component/toast/Toast";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import bg from "../../assets/gal3.jpg";
import Bread from "../../component/Bread";
const Contact = () => {
  // const { t } = useTranslation();
  // const dispatch = useDispatch();
  // const lan = useSelector((state) => state.LanSlicer.language);

  // const formik = useFormik({
  //   initialValues: {
  //     name: "",
  //     email: "",
  //     phone: "",
  //     message: "",
  //   },
  //   validateOnChange: true,
  //   onSubmit: (values) => {
  //     dispatch(formContact(values)).then((result) => {
  //       if (!result.error) {
  //         sucess(t("Congrats ... we will contact you soon"));
  //       } else {
  //         failed(t("please try again later ... "));
  //       }
  //     });
  //   },
  // });

  // const { info, SocialMedia, loading } = useSelector(
  //   (state) => state.contactSlice
  // );

  // const stripHtmlTags = (html) => {
  //   const doc = new DOMParser().parseFromString(html, "text/html");
  //   return doc.body.textContent || "";
  // };
  // const mapinfo = stripHtmlTags(
  //   info
  //     ?.map((item) => {
  //       if (item?.name === "الخريطة") {
  //         return item?.value;
  //       }
  //       return null;
  //     })
  //     .join("")
  // );

  // useEffect(() => {
  //   dispatch(getContactInfo(lan));
  //   dispatch(getSocialMedia(lan));
  // }, [lan, dispatch]);

  return (
 
    <>
       <Bread title={"Home"} sub={"Contact"} />

       

       

            <div id="map" className="mt-30 container">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3453.4143755971227!2d31.346704699999997!3d30.053654599999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f7d7002e2c3ee9%3A0x9fc2f769c23e6ec!2sPioneers%20Solutions!5e0!3m2!1sar!2seg!4v1730027510482!5m2!1sar!2seg" width="100%" height="450" style={{border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>

            <section className="section-wrap contact">
      <div className="container">
        <div className="row">

          <div className="col-md-8">
            <h5 className="uppercase mb-30">Send Us Message</h5>
            <form id="contact-form" action="#">

              <div className="contact-name">
                <input name="name" id="name" type="text" placeholder="Name*"/>
              </div>
              <div className="contact-email">
                <input name="mail" id="mail" type="email" placeholder="E-mail*"/>
              </div>
              <div className="contact-subject">
                <input name="subject" id="subject" type="text" placeholder="Subject"/>
              </div>                

              <textarea name="comment" id="comment" placeholder="Message" rows="9"></textarea>
              <input type="submit" className="btn btn-lg btn-color btn-submit" defaultValue="Submit" id="submit-message"/>
              <div id="msg" className="message"></div>
            </form>
          </div> 

          <div className="col-md-4 mb-40 mt-mdm-40 contact-info">

            <div className="address-wrap">
              <h4 className="uppercase">Address</h4>
              <h6>systems Store</h6>
              <address className="address">Cairo, PO Box 620067, Talay st. 66, A-ha inc.</address>
              <h6>Canada Store</h6>
              <address className="address">shop inc, 10-123 Main st. NW, QC, H3Z2Y7</address>
            </div>

            <h4 className="uppercase">Contact Info</h4>
            <ul className="contact-info-list">
              <li><span>Phone: </span><a href="tel:+1-888-1554-456-123">+ 1-888-1554-456-123</a></li>
              <li><span>Email: </span><a href="#" className="sliding-link">example@gmail.com</a></li>
              <li><span>Skype: </span><a href="#">Pioneers-Support</a></li>
            </ul>
            <h4 className="uppercase">Business Hours</h4>
            <p>Monday – Friday: 9am to 20 pm</p>
            <p>Saturday: 9am to 17 pm</p>
            <p>Sunday: closed</p>
          </div>          
        </div>
      </div>
    </section>
    </>
  );
};

export default Contact;
